import { FC } from 'react'
import styles from './IndividualClientsTable.module.css'
import { ClientsType } from '../../redux/actions/types'
import { useNavigate } from 'react-router-dom'
export type IndividualClientsTablePropsType = {
  data?: ClientsType[]
}

const IndividualClientsTable: FC<IndividualClientsTablePropsType> = ({ data }) => {
  const navigate = useNavigate()
  const individualClients = data?.filter((client) => client.type === 'individual')

  const handleRowClick = (clientId: string) => {
    navigate(`/clients-page?id=${clientId}`)
  }

  return (
    <div>
      <table className={styles.tableContainer}>
        <thead className={styles.tableHeader}>
          <tr className={styles.tableHeaderRow}>
            <th className={styles.headerItem}>ФИО</th>
            <th className={styles.headerItem}>Номер телефона</th>
            <th className={styles.headerItem}>Электронный Адрес</th>
          </tr>
        </thead>
        <tbody className={styles.tableBody}>
          {individualClients?.map((client) => (
            <tr
              className={styles.tableBodyRow}
              key={client?.id}
              onClick={() => handleRowClick(String(client?.id))}
            >
              <td className={styles.bodyItem}>{client?.fullName || '—'}</td>
              <td className={styles.bodyItem}>{client?.phone || '—'}</td>
              <td className={styles.bodyItem}>{client?.email || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default IndividualClientsTable
